import { CONTRACT_TYPE_ID } from '../constants/ObjectTypeIds';
export const NEVER_EDITABLE_PROPERTIES = new Set(['hs_hubspot_billing_enabled', 'hs_type', 'hs_contract_source', 'hs_contract_source_id']);
export const EDIT_DISABLED_PROPERTIES = new Set(['hs_hubspot_billing_enabled', 'hs_currency_code', 'hs_discount_code', 'hs_start_date', 'hs_end_date', 'hs_status', 'hs_payment_method', 'hs_contract_effective_date', 'hs_net_payment_terms', 'hs_collection_process', 'hs_type', 'hs_automated_taxes_enabled', 'hs_payment_enabled', 'hs_allowed_payment_methods']);
export function isReadOnlyContractProperty({
  objectTypeId,
  propertyName,
  hubspotDefined,
  hs_type
}) {
  if (objectTypeId !== CONTRACT_TYPE_ID || !hubspotDefined || !propertyName) {
    return false;
  }
  if (NEVER_EDITABLE_PROPERTIES.has(propertyName)) {
    return true;
  }
  if (hs_type === 'hubspot_managed') {
    return EDIT_DISABLED_PROPERTIES.has(propertyName);
  }
  return false;
}